import type { PickedItem } from '@src/scenario-editor/providers/fetch.context';

// LF360-2030: what the consumer's search hands back, folded into a node's
// individually selected list.

/**
 * The ids after a pick: the ones already selected, in their order, then the
 * new ones in the order they were picked. An id is never stored twice, so a
 * pick that repeats a selected item changes nothing.
 */
export function mergePickedIds(selectedIds: string[], picked: PickedItem[] | null | undefined): string[] {
  const ids = [...selectedIds];
  const seen = new Set(ids);

  for (const item of picked ?? []) {
    if (item?.id && !seen.has(item.id)) {
      seen.add(item.id);
      ids.push(item.id);
    }
  }

  return ids;
}

/**
 * The words for picked items, by id. The editor's own list is fetched once and
 * cached, so an item picked from a fresh search may be missing from it; without
 * these it would show as its bare id and be marked unavailable.
 */
export function pickedLabels(picked: PickedItem[] | null | undefined): Record<string, string> {
  return Object.fromEntries((picked ?? []).filter((item) => item?.id).map((item) => [item.id, item.text ?? '']));
}
